import CommonBox from './components/CommonBox'
import GifImagesSection from './components/GifImagesSection'
import EventTabSection from './components/EventTabSection'

const Event = () => {
   

    return (
        <>
            <section className='event-section'>
                <CommonBox heading=" 이벤트 " englishHeading=" event" isEnglishHeadingOnMobile={true} isAuthenticated={true}>
                    <EventTabSection />
                </CommonBox>
            </section>
            <section className='gif-section flex lg:hidden items-center justify-center'>
                <GifImagesSection />
            </section>
        </>
    )
}

export default Event